// components/HtmlText.tsx
import DOMPurify from "dompurify";

function isHtmlString(value: string) {
  return /<\/?[a-z][\s\S]*>/i.test(value);
}

type HtmlTextProps = {
  value?: string | null;
};

export function HtmlText({ value }: HtmlTextProps) {
  if (!value) return null;

  if (isHtmlString(value)) {
    const safeHtml = DOMPurify.sanitize(value);
    return <div dangerouslySetInnerHTML={{ __html: safeHtml }} />;
  }
  return <div>{value}</div>;
}
